import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { FormInput, FormPanel } from 'components/FormPanel';

import Button from 'primitives/Button';
import { Dialog, DialogPanel, DialogSubTitle, DialogTitle } from 'primitives/Dialog';

type CreateConversationMutationResponse = {
  createConversation: {
    id: string;
  };
};

type CreateConversationMutationVariables = {
  syndicateId: string;
  message: string;
  receiverId?: string;
};

const CREATE_CONVERSATION_MUTATION = gql(`
  mutation CreateConversationFromUserToSyndicate($syndicateId: ID!, $message: String!) {
    createConversation(syndicateId: $syndicateId, message: $message) {
      id
    }
  }
`);

const MessageSyndicateDialogButton: FC<{
  syndicateId: string;
  onClose: () => void;
  showButton?: boolean;
}> = ({ syndicateId, onClose, showButton = true }) => {
  const [open, setOpen] = useState<boolean>(!showButton ?? false);
  const navigate = useNavigate();

  const [createConversation, { loading, error }] = useMutation<
    CreateConversationMutationResponse,
    CreateConversationMutationVariables
  >(CREATE_CONVERSATION_MUTATION, {
    refetchQueries: ['InvestorConversationsQuery'],
  });

  return (
    <>
      {showButton && <Button onClick={() => setOpen(true)}>Message Syndicate</Button>}
      <Dialog
        open={open}
        onClose={() => {
          onClose();
          setOpen(false);
        }}
      >
        <DialogPanel>
          <DialogTitle>Message Syndicate</DialogTitle>
          <DialogSubTitle>
            Request information or ask questions about the syndicate. Your message will be sent to
            the syndicate lead.
          </DialogSubTitle>
          <FormPanel
            loading={loading}
            error={error}
            onSubmit={data =>
              createConversation({
                variables: {
                  syndicateId: syndicateId,
                  message: data.message,
                },
              }).then(response => {
                navigate(`/invest/conversations/${response.data?.createConversation.id}`);
                onClose();
                setOpen(false);
              })
            }
          >
            <FormInput fullWidth type="textarea" fieldName="message" label="" defaultValue="" />
          </FormPanel>
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default MessageSyndicateDialogButton;
